'use client';

import React from 'react';
import { StyledCtaBanner } from './AiSchemaTool.styles';

export const CtaBanner = () => {
  return (
    <StyledCtaBanner>
      <div className="banner-inner">
        <h2>Build a site worth marking up</h2>
        <p>
          CommonNinja has 226+ widgets: FAQs, accordions, reviews, feeds and more,
          all free to try. Add them to any website with no coding needed.
        </p>
        <a className="banner-cta" href="/widgets">Browse all free widgets &rarr;</a>
      </div>
    </StyledCtaBanner>
  );
};
